import { CURRENCY } from '../../../../constants/types';

export const priceFormatter = (price) =>
  price.toLocaleString('es-AR', {
    style: 'currency',
    currency: CURRENCY.ARS,
    minimumFractionDigits: 0,
  });
